import {
  HeaderFooterMachCore,
  SearchOrgDestResponse
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { CitiesDetails } from '@com-delta-idp/mnx-sitewide-shared-utils';

export function validateAEM(aem: HeaderFooterMachCore): boolean {
  return !!aem?.header?.book.vacations;
}

export function createTrigger(title: string, placeholder: string) {
  return { title: title || '', placeholder: placeholder || '' };
}

export function createDateRange(today: Date) {
  return {
    start: today,
    end: new Date(
      today.getFullYear() + 1,
      today.getMonth(),
      today.getDate() - 3
    )
  };
}

export function createMaxSelectionRange(today: Date) {
  return {
    start: today,
    end: new Date(
      today.getFullYear() + 1,
      today.getMonth() - 1,
      today.getDate() - 3
    )
  };
}

export function processAirportData(
  response: SearchOrgDestResponse
): CitiesDetails[] {
  return response?.vacationsObject?.cities || [];
}
